<template>
  <div class="componentRoot">
    <ButtonRowVue>
      <template v-slot:leftSide>
        <v-col :cols="searchBarCols" class="pr-2">
          <SearchBarVue
            :labelArray="['basics.name', 'basics.number']"
            @search="updateSearchQueue"
          />
        </v-col>
      </template>
      <v-col cols="auto" v-if="$checkRouterPermission('POST')">
        <v-tooltip :text="$t('basics.new', { type: $t('basics.diagnosis') })">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              @click="showEditDiagnosis($event)"
              class="primaryButton squareButton"
              flat
              ><v-icon size="x-large">mdi-plus</v-icon></v-btn
            >
          </template>
        </v-tooltip>
      </v-col>
    </ButtonRowVue>

    <TableVue
      :numPages="numPages"
      @switchPage="switchPage"
      id="diagnosisTable"
      :resetPage="resetPage"
      :total="totalCount"
    >
      <thead>
        <tr>
          <th
            class="text-left"
            @click="switchSortBy('number')"
            style="width: 120px"
            :style="{
              color: sortBy == 'number' ? 'rgb(var(--v-theme-primary))' : 'unset',
            }"
          >
            <div style="display: flex; align-items: center">
              <b style="font-size: medium">{{ $t("basics.number") }}</b>
              <div v-if="sortBy == 'number'">
                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                <v-icon v-else>mdi-menu-down</v-icon>
              </div>
              <div v-else>
                <v-icon>mdi-menu-right</v-icon>
              </div>
            </div>
          </th>

             <th
            class="text-left"
            @click="switchSortBy('name')"
            :style="{
              color: sortBy == 'name' ? 'rgb(var(--v-theme-primary))' : 'unset',
            }"
          >
            <div style="display: flex; align-items: center">
              <b style="font-size: medium">{{ $t("basics.name") }}</b>

              <div v-if="sortBy == 'name'">
                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                <v-icon v-else>mdi-menu-down</v-icon>
              </div>
              <div v-else>
                <v-icon>mdi-menu-right</v-icon>
              </div>
            </div>
          </th>

          <th
            v-if="!isMobile"
            class="text-left"
            @click="switchSortBy('lastUpdated')"
            :style="{
              color: sortBy == 'lastUpdated' ? 'rgb(var(--v-theme-primary))' : 'unset',
            }"
          >
            <div style="display: flex; align-items: center">
              <b style="font-size: medium">{{ $t("basics.lastUpdated") }}</b>
              <div v-if="sortBy == 'lastUpdated'">
                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                <v-icon v-else>mdi-menu-down</v-icon>
              </div>
              <div v-else>
                <v-icon>mdi-menu-right</v-icon>
              </div>
            </div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody    v-for="diagnosis in diagnoses"
          :key="diagnosis.id">
        <tr
          @click="showEditDiagnosis($event, diagnosis)"
        >
          <td 
            style="width: 120px">
             <div style="display: flex; align-items: center;">
            <v-tooltip  v-if="diagnosis.default_bill" :text="$t('messages.defaultBillDiagnosis')">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" class="mr-2" color="primary">mdi-star</v-icon>
              </template>
            </v-tooltip>

            {{ diagnosis.number }}
            </div>
          </td>
          <td>
            {{ diagnosis.name }}
          </td>
          <td v-if="!isMobile">
            {{ getReadableDatetime(diagnosis.last_updated) }}
          </td>
          <td class="text-right">
            <v-tooltip :text="$t('basics.edit', { type: $t('basics.diagnosis') })">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props"> mdi-pencil </v-icon>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </tbody>

      <tbody v-if="!diagnoses || diagnoses.length == 0">
        <tr>
          <td colspan="400">
            <i>{{ $t("messages.noItems") }}</i>
          </td>
        </tr>
      </tbody>
    </TableVue>

    <DiagnosisEditVue
      :refreshDisplay="editDiagnosisDrawer"
      @close="closeEditDiagnosis"
      :diagnosisData="activeDiagnosis"
      @delete="showDeleteDiagnosis"
      :readonly="!$checkRouterPermission('POST') && !$checkRouterPermission('PATCH')"
    />

    <DeletionWarningVue
      :type="'diagnosis'"
      :additionalMessage="
        $t('messages.confirmDeletionItem', { item: activeDiagnosis?.name })
      "
      :refreshDisplay="deleteDiagnosisDrawer"
      @delete="deleteDiagnosis"
      style="z-index: 1007 !important"
    />

    <LoadingScreenVue :loading="loading" />
  </div>
</template>

<script>
import DiagnosisEditVue from "../../../components/settings/DiagnosisEdit.vue";

export default {
  name: "diagnosisList",

  data() {
    return {
      diagnoses: undefined,

      activeDiagnosis: undefined,
      editDiagnosisDrawer: 0,
      deleteDiagnosisDrawer: 0,

      currPage: 1,
      numPages: undefined,
      totalCount: undefined,
      resetPage: 0,


      searchQueue: undefined,
      searchParams: undefined,

      filterParams: undefined,

      sortBy: "number",
      sortDirection: true,

      loading: false,
    };
  },

  computed: {
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
    searchBarCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 9;
        case "sm":
          return 9;
        case "md":
          return 6;
        case "lg":
          return 4;
        case "xl":
          return 4;
        case "xxl":
          return 3;
        default:
          return 4;
      }
    },
  },

  components: {
    DiagnosisEditVue,
  },

  methods: {
    getIcon(diagnosis) {
      switch (diagnosis.display_type) {
        case "hotel":
          return "mdi-bunk-bed";
        case "campus":
          return "mdi-table-chair";
        case "gym":
          return "mdi-garage-open-variant";
        case "multiUse":
          return "mdi-dots-horizontal-circle-outline";
        case "external":
          return "mdi-open-in-new";
        default:
          return "mdi-table-chair";
      }
    },
    fetchData() {
      this.setLoading(true);

      let searchParams =
        "?page=" +
        this.currPage +
        "&order=" +
        this.sortBy +
        "&direction=" +
        (this.sortDirection ? "up" : "down");

      if (this.searchParams) {
        searchParams += this.searchParams;
      }

      if (this.searchQueue) {
        searchParams += "&query=" + this.searchQueue;
      }

      if (this.filterParams) {
        searchParams += this.filterParams;
      }

      this.axios
        .get(this.axios.defaults.baseURL + "media/diagnosis/" + searchParams)
        .then((resp) => {
          this.setLoading(false);
          this.diagnoses = resp.data.results;
          this.totalCount = resp.data.count;

          if (resp.data.results.length == 0) {
            this.numPages = 0;
          } else if (this.currPage == 1) {
            this.numPages = Math.ceil(resp.data.count / resp.data.results.length);
          }
        })
        .catch((e) => {
          this.setLoading(false);
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    setLoading(value) {
      this.loading = value;
    },
    showEditDiagnosis(event, diagnosis) {
      event.preventDefault();
      event.stopPropagation();

      this.activeDiagnosis = diagnosis;
      this.editDiagnosisDrawer++;
    },
    closeEditDiagnosis(value) {
      this.activeDiagnosis = undefined;
      this.editDiagnosisDrawer = 0;

      this.setLoading(false);

      if (value) {
        this.fetchData();
      }
    },
    switchPage(data) {
      this.currPage = data;

      this.fetchData();
    },
    getReadableDatetime(datetime) {
      if (datetime) return this.$moment(datetime).format("DD.MM.YYYY HH:mm");
      else return undefined;
    },
    updateSearchQueue(value) {
      this.resetPage++;
      this.currPage = 1;
      this.searchQueue = value;

      this.fetchData();
    },
    switchSortBy(val) {
      if (this.sortBy != val) {
        this.sortBy = val;
        this.sortDirection = true;
      } else {
        this.sortDirection = !this.sortDirection;
      }

      this.currPage = 1;
      this.resetPage++;

      this.fetchData();
    },
    applyFilter(query) {
      this.resetPage++;
      this.filterParams = query;
      this.fetchData();
    },
    showDeleteDiagnosis(diagnosis) {
      this.activeDiagnosis = diagnosis;
      this.deleteDiagnosisDrawer++;
    },
    deleteDiagnosis() {
      this.setLoading(true);
      this.axios
        .patch(
          this.axios.defaults.baseURL +
            "ressource/diagnoses/delete/" +
            this.activeDiagnosis.id,
          {
            deleted: true,
          }
        )
        .then(() => {
          this.setLoading(false);
          this.deleteDiagnosisDrawer = 0;
          this.editDiagnosisDrawer = 0;
          this.fetchData();
        })
        .catch((e) => {
          this.setLoading(false);
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
